// src/components/Footer.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../styles/Footer.css'; // We will create this CSS file next

export default function Footer() {
  const [data, setData] = useState({
    logoText: 'PharmaLedger',
    footerDescription: 'Smart pharmacy management system.',
    footerLinks: [],
    contactEmail: 'support@pharmaledger.com',
    contactPhone: '+977 00000 00000',
    contactAddress: '123 Pharmacy '
  });

  useEffect(() => {
    // Fetch landing page data to populate footer dynamically
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/landing-page`);
        if (response.data) {
          setData(prev => ({ ...prev, ...response.data }));
        }
      } catch (error) {
        console.error("Footer data fetch failed, using defaults");
      }
    };
    fetchData();
  }, []);

  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer-grid">
          {/* Brand */}
          <div className="lp-footer-col">
            <div className="lp-brand" style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
              <img 
                src="./images/logoo.png" 
                alt="Logo" 
                style={{ width: '30px', height: 'auto', marginRight: '0.75rem' }} 
              />
              <span className="lp-brand-text" style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--lp-text-main)' }}>
                {data.logoText}
              </span>
            </div>
            <p style={{ color: 'var(--lp-text-muted)', lineHeight: 1.6 }}>
              {data.footerDescription}
            </p>
          </div>

          {/* Dynamic Links */}
          {data.footerLinks?.length > 0 ? (
            data.footerLinks.map((section, index) => (
              <div key={index} className="lp-footer-col">
                <h4>{section.title}</h4>
                {section.links?.map((link, i) => (
                  <a key={i} href={link.url} className="lp-footer-link">
                    {link.label}
                  </a>
                ))}
              </div>
            ))
          ) : (
             /* Fallback Links if API fails */
             <>
               <div className="lp-footer-col">
                 <h4>Product</h4>
                 <Link to="/features" className="lp-footer-link">Features</Link>
                 <Link to="/pricing" className="lp-footer-link">Pricing</Link>
               </div>
               <div className="lp-footer-col">
                 <h4>Legal</h4>
                 <Link to="/privacy" className="lp-footer-link">Privacy Policy</Link>
                 <Link to="/terms" className="lp-footer-link">Terms of Service</Link>
               </div>
             </>
          )}

          {/* Contact */}
          <div className="lp-footer-col">
            <h4>Contact</h4>
            <p style={{ color: 'var(--lp-text-muted)', marginBottom: '0.5rem' }}>{data.contactEmail}</p>
            <p style={{ color: 'var(--lp-text-muted)', marginBottom: '0.5rem' }}>{data.contactPhone}</p>
            <p style={{ color: 'var(--lp-text-muted)' }}>{data.contactAddress}</p>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <p>&copy; {new Date().getFullYear()} {data.logoText}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}